import { useEffect } from 'react';
import useAuthStore from '@oncolens/oncolens-ui/lib/stores/AuthStore';
import Logger from '@/utils/loggingService';
import { useLocation } from 'react-router-dom';

export default function useLogging() {
  const domainUser = useAuthStore((x) => x.domainUser);
  useEffect(() => {
    if (domainUser) {
      Logger.setupLoggerContext(domainUser.id);
    }
  }, [domainUser]);

  const location = useLocation();
  useEffect(() => {
    Logger.logRouteChange(`${location.pathname}${location.search}`);
  }, [location]);
}
